import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { getSingleRecipe } from '../actions/recipeActions';
import { Col, Row, ListGroup, ListGroupItem, Container } from 'reactstrap';
import Spinner from './Spinner';
import { Helmet } from 'react-helmet';
import { useLocation, useParams } from 'react-router-dom';

const RecipeLink = (props: any) => {
  const { recipes } = props;
  const location = useLocation() as any;
  const params = useParams() as any;

  const [recipe, setRecipe] = useState<any>({});
  const prevRecipeRef = useRef(recipes.recipe);

  useEffect(() => {
    if (location.state === undefined) {
      props.getSingleRecipe(params.recipeid);
    }
    if (location.state !== undefined && location.state.recipe) {
      setRecipe(location.state.recipe);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (recipes.recipe !== prevRecipeRef.current) {
      prevRecipeRef.current = recipes.recipe;
      setRecipe(recipes.recipe);
    }
  });

  return (
    <div>
      <div>
        <Helmet>
          <title>
            {location.state !== undefined && location.state.recipe
              ? location.state.recipe.title
              : params.title.replace(/-/g, ' ')}{' '}
            - Frozberries Victoria
          </title>
          <meta
            name="description"
            content={`${
              location.state !== undefined && location.state.recipe
                ? location.state.recipe.title
                : params.title.replace(/-/g, ' ')
            } - Frozberries Victoria`}
          />
        </Helmet>
      </div>

      <div>
        {Object.keys(recipe).length > 0 ? (
          <div>
            <div className=" mt-3 py-5 bg-light">
              <Container>
                <Row className=" px-3 py-3">
                  <Col md="6" sm="12">
                    <h1 className="font-weight-bold">{recipe.title}</h1>
                    <h5 className="text-muted">{recipe.description}</h5>
                  </Col>
                  <Col md="6" sm="12">
                    <img className="img-fluid" src={recipe.recipeImage} alt={recipe.title} />
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="container mt-3 py-5 ">
              <Row className="px-3 py-3 text-center mt-2">
                <Col md="3" sm="6" className="my-3">
                  <div>
                    <i className="fas fa-utensils fa-4x text-info"></i>
                  </div>
                  <div>
                    <h5 className="text-muted mt-3">Prep Time</h5>
                    <h1 className="font text-info" style={{ fontSize: '3rem' }}>
                      {recipe.prepTime}
                    </h1>
                  </div>
                </Col>
                <Col md="3" sm="6" className="my-3">
                  <div>
                    <i className="far fa-clock fa-4x text-info"></i>
                  </div>
                  <div>
                    <h5 className="text-muted  mt-3 ">Total Time</h5>
                    <h1 className="font  text-info" style={{ fontSize: '3rem' }}>
                      {recipe.totalTime}
                    </h1>
                  </div>
                </Col>
                <Col md="3" sm="6" className="my-3">
                  <div>
                    <i className="fas fa-fire fa-4x text-info"></i>
                  </div>
                  <div>
                    <h5 className="text-muted  mt-3">Calories Per Serving</h5>
                    <h1 className="font text-info" style={{ fontSize: '3rem' }}>
                      {recipe.caloriesPerServing}
                    </h1>
                  </div>
                </Col>
                <Col md="3" sm="6" className="my-3 ">
                  <div>
                    <i className="fas fa-concierge-bell fa-4x text-info"></i>
                  </div>
                  <div>
                    <h5 className="text-muted  mt-3">Servings</h5>
                    <h1 className="font text-info" style={{ fontSize: '3rem' }}>
                      {recipe.servings}
                    </h1>
                  </div>
                </Col>
              </Row>

              <Row className="px-3 py-3 mt-2">
                <Col md="4" sm="12" className="my-3">
                  <div>
                    <h3 className="mt-3 font-weight-bold border-bottom">
                      Ingredients ({recipe.ingredients.length})
                    </h3>
                  </div>
                  <div>
                    <ul style={{ paddingInlineStart: 10 }}>
                      {recipe.ingredients.map((ingredient) => (
                        <li className="px-0 my-3 " style={{ fontSize: '1.1rem' }}>
                          {ingredient.step}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Col>
                <Col md="8" sm="12" className="my-3">
                  <div>
                    <h3 className="mt-3 font-weight-bold border-bottom">Directions</h3>
                  </div>
                  <div>
                    <ListGroup>
                      {recipe.directions.map((direction, index) => (
                        <ListGroupItem style={{ fontSize: '1.2rem' }} className="px-0 border-0">
                          <div
                            className="rounded-circle text-white shadow px-3 py-3 bg-danger mr-2  mb-1"
                            style={{
                              width: '3em',
                              height: '3em',
                              alignItems: 'center',
                              justifyContent: 'center',
                              display: 'inline-flex',
                              textAlign: 'center',
                            }}
                          >
                            {index + 1}
                          </div>
                          {direction.direction}
                        </ListGroupItem>
                      ))}
                    </ListGroup>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          recipes.loading && (
            <div className="text-center">
              <Spinner />
            </div>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  recipes: state.recipes,
});

export default connect(mapStateToProps, { getSingleRecipe })(RecipeLink);
